import React, { useState, useEffect } from 'react';
import { styled } from "@mui/system";
import { Slider, IconButton, Stack } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const Scrollbar = styled(Slider)(() => (
    {
        '& .MuiSlider-track': {
            width: '8px',
            opacity: 1,
            backgroundColor: 'rgb(255 255 255)',
            // backgroundColor: 'rgba(43, 85, 150, 1)',
            // border: '2px solid rgba(0, 0, 0, 0.3)',
        },
        '& .MuiSlider-thumb': {
            height: '10px',
            width: '10px',
            backgroundColor: 'rgb(255 255 255)',
            // boxShadow: '0 0 2px 0px rgba(0, 0, 0, 0.1)',
        },
        '& .MuiSlider-rail': {
            width: '8px',
            // opacity: 1,
            // boxShadow: 'inset 0px 0px 4px -2px #000',
            backgroundColor: 'rgba(184, 184, 184, 1)',
        },

    }));

const VerticalSlider = (props) => {

    // データが更新された時
    useEffect(() => {
        // スライダー設定
        // value[0] < value[1]
        const data_len = props.dataLength
        if (data_len < props.distance) {
            props.setValue([0, data_len]);
        } else {
            props.setValue([data_len - props.distance, data_len]);
        }
    }, [props.dataLength])

    const handleChange = (event, newValue, activeThumb) => {
        if (!Array.isArray(newValue)) {
            return;
        }
        const data_len = props.dataLength - 1

        if (activeThumb === 0) {
            // 下のポイント変更
            if (newValue[0] > data_len - props.distance) {
                props.setValue([data_len - props.distance, data_len]);
            } else {
                props.setValue([newValue[0], newValue[0] + props.distance]);
            }
        } else {
            // 上のポイント変更
            if (newValue[1] < props.distance) {
                props.setValue([0, props.distance]);
            } else {
                props.setValue([newValue[1] - props.distance, newValue[1]]);
            }
        }
    };

    // スライダーを下に１ステップ移動
    const handleIncrement = () => {
        props.setValue(prev => {
            // 上限チェック
            if (prev[1] >= props.dataLength - 1) return prev;
            return [prev[0] + 1, prev[1] + 1];
        });
    };

    // スライダーを上に１ステップ移動
    const handleDecrement = () => {
        props.setValue(prev => {
            // 下限チェック
            if (prev[0] <= 0) return prev;
            return [prev[0] - 1, prev[1] - 1];
        });
    };

    return (
        <Stack height={props.height}
            direction="column"
            justifyContent="space-between"
            alignItems="center">
            <IconButton size='small'
                onClick={handleIncrement}
                // disabled={props.value[0] < 1}
                sx={{
                    width: 32,
                    height: 32,
                    color: 'rgb(255 255 255)'
                }}>
                <KeyboardArrowUpIcon
                    sx={{ width: '100%', height: '100%' }} />
            </IconButton>
            <Scrollbar
                sx={{ flex: 1, width: '100%' }}
                size="small"
                onChange={handleChange}
                value={props.value}
                max={props.dataLength - 1}
                // min={0}
                // max={props.dataLength - props.distance}
                valueLabelDisplay="auto"
                orientation='vertical'
            />
            <IconButton size='small'
                onClick={handleDecrement}
                // disabled={props.value[1] > props.dataLength - 1}
                sx={{
                    width: 32,
                    height: 32,
                    color: 'rgb(255 255 255)'
                }}>
                <KeyboardArrowDownIcon
                    sx={{ width: '100%', height: '100%' }} />
            </IconButton>
        </Stack>
    )
}
export default VerticalSlider;
